import { IResolvePaymentLinkResponse } from "commons/clients";
import { ECommunityCode } from "features/common";

export const mockResolvePaymentLinkResponse: IResolvePaymentLinkResponse = {
  result: {
    communityAccountId: 10000000,
    invoiceId: 3012970,
    clientSecret: "pi_3TJwNuBHuGTb0F4a1pd0SeWA_secret_apxbZ1kIPpxwbK3Q4tvmc8fAk",
    paymentIntentId: "pi_3TJwNuBHuGTb0F4a1pd0SeWA",
    amount: 886.8,
    currency: "EUR",
    requestReference: "69a73849-b2cf-4f81-a97e-83920a859e32",
    lang: "fr",
    checkout: {
      mainProduct: {
        name: "Business Essentiel",
        amount: 739.0
      },
      joiningFee: null,
      marketplaceOptOut: null,
      subTotal: 739.0,
      vat: 147.8,
      total: 886.8
    },
    paymentMethods: [2],
    billing: {
      firstName: "Agnès",
      lastName: "BONNET",
      email: "abonnet@diffazur.fr",
      address: {
        line1: "44 ALL DES ARCHITECTES",
        line2: "",
        town: "SAINT-LAURENT-DU-VAR",
        postCode: "06700",
        country: "FRANCE",
        county: ""
      }
    },
    activeCommunities: [
      {
        communityAccountId: 1,
        code: ECommunityCode.UK
      },
      {
        communityAccountId: 10000000,
        code: ECommunityCode.FR
      }
    ],
    content: {
      productSiloId: 9,
      productSiloName: "Business",
      productId: 77,
      productName: "Essentiel",
      iconUrl: "/Essentiel.svg",
      iconAlt: "",
      description: "Confirm the Essentiel plan and complete your secure payment here."
    }
  },
  isSuccess: true,
  message: "",
  validationIssues: null
};
